<div class="loading">
    <mat-spinner></mat-spinner>
    <h1 style="color:black ;">Loading...</h1>
  </div>